<template>
  <div
    ref="el_module"
    class="module"
    :class="[
      type === 'edit' ? 'center_module_edit' : 'left_module_view',
      is_select ? 'now_module_select' : '',
      module_selectable,
      module.lock ? 'module_locking' : '',
      module.var ? 'variable_module' : ''
    ]"
    :style="{
      width: module.style.width + 'px',
      height: module.style.height + 'px',
      top: module.style.top + 'px',
      left: module.style.left + 'px',
      opacity:  module.style.opacity
    }"
    :id="type === 'edit' ? 'u' + module.tid : 'v' + module.tid"
    @mousedown.stop="module_mousedown"
    @mouseup="module_mouseup"
    @click.stop="select_module"
    @dblclick="on_dblclick_module"
    @contextmenu.stop="module_contextmenu"
    :name="module.name"
    :cmptype="module.cmpType"
  >
    <div
      class="relativeFrame"
      :style="{
        transform: `rotate(${module.style.rotate}deg)`
      }"
    >
      <component ref="widget" :is="module.cmpType + '_index'" :module="module" :index="index" :type="type"></component>
      <div class="m_ctrl" v-show="m_ctrl_visible" @dblclick="ondblclick">
        <div class="flag" v-if="module.var">变量</div>
      </div>
      <!--      <div class="m_ctrl" v-if="module.cmpType != 'text'"></div>-->
      <div class="module_locking_mantle" @mousedown.stop @mouseup.stop v-show="module.lock"></div>
      <div class="rotate_icon " @mousedown.stop v-show="type === 'edit' && !module.lock">
        <i class="el-icon-reset rotate_icon_btn"></i>
      </div>
      <div class="operate_button"  @mousedown.stop v-show="type === 'edit' && !module.lock ">
        <div class="delete button mr-16" @click="delect">
            <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-shanshu14"></use>
            </svg>
        </div>
        <div class="copy button" @click="copy">+1</div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'BasicModule',
  data() {
    return {
      max_animate_delay: 0,
      forbit_drag_arr: ['praise', 'wipe', 'lock', 'fingerprint', 'chat'], // 禁止缩放的挂件
      forbit_move_arr: ['wipe', 'lock', 'fingerprint', 'chat'], // 禁止移动的挂件
      forbit_rotate_arr: ['wipe', 'lock', 'fingerprint', 'pictures', 'chat'], // 禁止旋转的挂件
      clickFlag: false,
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 0
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    delect() {
      // 删除
      this.templet.select_module_delect()
    },
    copy() {
      // 复制
      this.templet.copy_module()
      // 粘贴
      setTimeout(() => {
        this.templet.paste_module()
      }, 500)
    },
    is_exist_selected(tid) {
      let isExist = false
      const select_module = this.$store.state.widgets.select_module
      for (let i = 0; i < select_module.length; i++) {
        if (select_module[i].tid === tid) {
          isExist = true
          break
        }
      }
      return isExist
    },
    on_dblclick_module() {
      if (this.module.gid) {
        this.is_move()
      }
    },
    module_mousedown(e) {
      // 记录下鼠标位置
      this.x1 = e.clientX
      this.y1 = e.clientY
    },
    module_mouseup(e) {
      // 记录下鼠标位置
      this.x2 = e.clientX
      this.y2 = e.clientY
      // 判断鼠标是否移动
      const x1 = this.x1
      const x2 = this.x2
      const y1 = this.y1
      const y2 = this.y2
      const d = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))
      if (d === 0 || d < 7) {
        this.clickFlag = true
      } else {
        this.clickFlag = false
      }
    },
    select_module(e) {
      // if (!this.clickFlag) return
      if (this.module.gid) {
        return this.click_module_in_group(e)
      }
      const tid = this.module.tid
      if (e.ctrlKey) {
        const isExist = this.is_exist_selected(tid)
        if (isExist) {
          // 存在该挂件,应该在已选的挂件中删除
          this.$store.commit('widgets/DEL_select_module', tid)
        } else {
          console.log(98)
          // 不存在就加入进去
          this.$store.commit('widgets/ADD_select_module', this.module)
          // 关闭当前编辑状态
          this.$store.commit('widgets/SET_module_Data', null)
        }
      } else {
        this.is_move()
      }
      this.$store.commit('contextmenu_dialog/SET_isShow', false)
    },
    click_module_in_group(e) {
      // console.log('click_module_in_group')
      if (e.ctrlKey) {
        this.click_module_in_group_with_ctrl(e)
      } else {
        this.click_module_in_group_no_ctrl(e)
      }
    },
    click_module_in_group_no_ctrl(e) {
      const gid = this.module.gid
      const page = this.$store.state.body.data.pages
      page.cmps.forEach(m => {
        if (m.gid === gid) {
          this.$store.commit('widgets/ADD_select_module', m)
        }
      })
      this.$store.commit('widgets/SET_module_Data', null)
    },
    click_module_in_group_with_ctrl() {
      const tid = this.module.tid
      const isExist = this.is_exist_selected(tid)
      if (isExist) {
        // 存在该挂件,应该在已选的挂件中删除
        this.$store.commit('widgets/DEL_select_module', tid)
      } else {
        // 不存在就加入进去
        if (!this.$store.state.widgets.select_module.length) {
          this.templet.select_one_module(this.module)
        } else {
          this.$store.commit('widgets/ADD_select_module', this.module)
          this.$store.commit('widgets/SET_module_Data', null)
        }
      }
    },
    is_move() {
      if (!this.$store.state.widgets.multiple_selection_move) {
        this.templet.select_one_module(this.module)
      } else {
        // 这里是多个挂件移动后触发，重置状态
        this.$store.commit('widgets/SET_selection_move', false)
      }
    },
    delect_module() {
      this.templet.p_delect_module(this.module.tid)
    },

    module_contextmenu(e) {
    //   if ($(e.target).hasClass('my-contenteditable')) {
    //     return
    //   }
      e.preventDefault()
      const select_module = this.$store.state.widgets.select_module

      if (select_module.length <= 1) {
        // 执行点击状态
        // 这里是单个点击 或 单个移动后触发
        this.templet.select_one_module(this.module)
      } else {
        // 如果当前是多选状态，判断右击的那个是否是多选队列中的
        const noHave = this.templet.select_module_has(this.module.tid)
        if (noHave) {
          this.templet.select_one_module(this.module)
        }
      }

      this.$store.commit('contextmenu_dialog/SET_isShow', true)
      this.$store.commit('contextmenu_dialog/SET_type', 'module')

      this.$nextTick(() => {
        const p = this.templet.contextmenu_position(e)
        this.$store.commit('contextmenu_dialog/SET_top', p.y)
        this.$store.commit('contextmenu_dialog/SET_left', p.x)
      })
    },
    unlock() {
      this.module.lock = false
    },
    ondblclick() {
      console.log('ondblclick mctrl')
      if (this.module.cmpType === 'text') {
        this.$refs.widget.on_double_click()
      }
    },

    // 部分属性初始化
    module_val_init() {
      if (typeof this.module.style.opacity === 'undefined') {
        this.$set(this.module.style, 'opacity', 1)
      }
      if (typeof this.module.style.rotate === 'undefined') {
        this.$set(this.module.style, 'rotate', 0)
      }
    }
  },
  computed: {
    m_ctrl_visible() {
      if (this.module.cmpType === 'text') {
        return !this.module.isEditing
      } else {
        return true
      }
    },
    is_select() {
      const module = $(`#u${this.module.tid}`)
      let end = false
      if (this.$store.state.widgets.module_Data && this.$store.state.widgets.module_Data.tid === this.module.tid) {
        if (!this.forbit_drag_arr.includes(this.module.cmpType)) {
          this.templet.moudle_resizable_methods(module.find('.relativeFrame'))
        }
        end = true
      } else {
        if (module.find('.ui-resizable').length) {
          module.find('.relativeFrame').resizable('destroy')
        }
      }
      return end
    },
    module_selectable() {
      let end = ''
      const select_module = this.$store.state.widgets.select_module
      for (let i = 0; i < select_module.length; i++) {
        if (this.module.tid === select_module[i].tid) {
          if (!this.module.lock) {
            // 未锁定正常多选
            end = 'module_selectable_select'
          } else {
            // 锁定多选
            end = 'module_selectable_lock_select'
          }
          break
        }
      }
      return end
    }
  },
  created() {
    this.module_val_init()
  },
  mounted() {
    const module = $(`#u${this.module.tid}`)
    if (this.type === 'edit') {
      if (!this.forbit_move_arr.includes(this.module.cmpType)) {
        this.templet.moudle_draggable_methods(module)
      }

      // if (!this.forbit_drag_arr.includes(this.module.cmpType)){
      //  this.templet.moudle_resizable_methods(module.find('.relativeFrame'));
      // }

      if (!this.forbit_rotate_arr.includes(this.module.cmpType)) {
        this.templet.moudle_rotate_methods(module)
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.variable_module .relativeFrame {
  ::v-deep .basic_image img {
    object-position: left top !important;
  }
}
.operate_button{
    display: flex;
    position: absolute;
    bottom: -25px;
    left:50%;
    width: 0;
    height: 0;
    margin-left: -32px;
    .icon{
        width: 15px;
        height: 15px;
    }
    .button{
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0;
        height: 0;
        background: #165DFF;
        cursor: pointer;
        font-size: 14px;
        color: #fff;
    }
}
.center_frame .layout_body .module {
  cursor: move;
  position: absolute;
  width: auto !important;
  height: auto !important;

  .relativeFrame {
    position: relative;
    width: 100%;
    height: 100%;
  }
}

.m_ctrl {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: 1px transparent solid;
  .flag {
    display: none;
    position: absolute;
    right: 0;
    top: -20px;
    width: 38px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    color: #ffffff;
    background: #0086ff;
    border-radius: 4px 4px 0px 0px;
  }
}

.m_ctrl:hover {
  .flag {
    display: block;
  }
  border: 1px #1261ff solid;
}

.module_selectable_select .m_ctrl {
  border-color: #1261ff;
  border-style: solid;
  .flag {
    display: block;
  }
}

.module_selectable_lock_select .m_ctrl {
  border-color: #f00;
  border-style: solid;
}

// .module_selectable_select .basic_text {
//   outline: 1px #1261ff solid;
// }

.basic_text:hover {
  outline: 1px #1261ff solid;
}

.module .rotate_icon {
  display: none;
  top: -29px;
  left: 50%;
  width: 24px;
  height: 24px;
  background: #1261ff;
  text-align: center;
  position: absolute;
  margin-left: -12px;
  border-radius: 50%;
    color: #fff;
  i {
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: block;
    line-height: 24px;
    cursor: move;
  }
}

.now_module_select {
    .rotate_icon{
        display: block;
    }
    .operate_button{
        width: auto;
        height: auto;
        .button{
            width: 24px;
            height: 24px;
        }
    }
}
</style>
